import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      navigate("/admin");
    } else {
      setError(res.error || "Login failed");
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#040405] px-6">
      <div className="absolute inset-0 grid-lines opacity-40" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="glass relative z-10 w-full max-w-md rounded-2xl p-8"
        data-testid="admin-login-card"
      >
        <Logo height={30} />
        <div className="mt-8">
          <div
            className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl border border-white/10"
            style={{ background: "rgba(255,255,255,0.03)" }}
          >
            <Lock className="h-5 w-5" style={{ color: "var(--accent)" }} />
          </div>
          <h1 className="font-display text-2xl font-medium text-white">
            Admin Console
          </h1>
          <p className="font-body mt-1 text-sm text-white/50">
            Sign in to manage site content.
          </p>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="font-mono mb-2 block text-[11px] tracking-[0.15em] text-white/50">
              EMAIL
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email-input"
              className="w-full rounded-lg border border-white/10 bg-white/[0.03] px-4 py-3 font-body text-white outline-none transition-colors focus:border-[var(--accent)]"
              placeholder="admin@cogentis.tech"
            />
          </div>
          <div>
            <label className="font-mono mb-2 block text-[11px] tracking-[0.15em] text-white/50">
              PASSWORD
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password-input"
              className="w-full rounded-lg border border-white/10 bg-white/[0.03] px-4 py-3 font-body text-white outline-none transition-colors focus:border-[var(--accent)]"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <p
              className="font-body text-sm text-red-400"
              data-testid="admin-login-error"
            >
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="flex w-full items-center justify-center gap-2 rounded-lg px-4 py-3 font-medium text-white transition-opacity disabled:opacity-60"
            style={{ background: "var(--accent)" }}
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Sign In
          </button>
        </form>
      </motion.div>
    </div>
  );
}
